import React, { useEffect } from "react";
import { connect } from 'react-redux';
import SupportedClientTypeForm from "./SupportedClientTypeForm";
import * as Yup from "yup";
import * as actions from './store/supportedClientTypeActions';
import History from "../../../History";
import { hasPermission } from "../../sc-utilities";
import { CancelToken } from 'axios';
import { parseURL } from "../../sc-utilities";

const SupportedClientTypeEdit = props => {
    const { activeCustomerID, translations, updateSupportedClientType, permissions, supportedClientType, loadSupportedClientType, loadSupportedClientTypeInit } = props;

    useEffect(() => {
        const requestToken = CancelToken.source();
        const fetchData = async () => {
            await loadSupportedClientType({ ActiveCustomerID: activeCustomerID, SupportedClientTypeID: parseURL(window.location.href).SupportedClientTypeID }, { cancelToken: requestToken.token })
        }
        fetchData();
        return () => {
            requestToken.cancel('Operation canceled by the user.');
            loadSupportedClientTypeInit();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleSubmit = async data => {
        let formData = { ...data };
        formData['CustomerID'] = activeCustomerID;
        formData['SupportedClientTypeID'] = parseURL(window.location.href).SupportedClientTypeID;
        let result = await updateSupportedClientType({ ...formData, ActiveCustomerID: activeCustomerID });
        if (result) {
            History.goBack();
        }
    };

    let initialValues = {
        Key: supportedClientType?.Key || '',
        Name: supportedClientType?.Name || '',
        MajorVersion: supportedClientType?.MajorVersion || 0,
        MinorVersion: supportedClientType?.MinorVersion || 0,
        BuildNumber: supportedClientType?.BuildNumber || 0
    };

    let formSettings = {
        Validation: {
            Key: Yup.string().required("Key"),
            Name: Yup.string().required("Required"),
            MajorVersion: Yup.number().min(0).required('Required'),
            MinorVersion: Yup.number().min(0).required('Required'),
            BuildNumber: Yup.number().min(0).required('Required')
        },
        FormTitle: translations["edit_supported_client_type"] || "Edit supported client type",
        ButtonSubmit: hasPermission(permissions, 'supported_client_type_save') ? {
            Title: translations["save"] || "SAVE"
        } : null
    };

    return <SupportedClientTypeForm
        formSettings={formSettings}
        initialValues={initialValues}
        handleSubmit={handleSubmit}
        translations={translations}
    />;
};

const mapStateToProps = state => {
    return {
        activeCustomerID: state.core.login.activeCustomer.CustomerID,
        supportedClientType: state.admin.supportedClientType.loaded,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        permissions: state?.core?.login?.permissions || []
    };
};

const mapDispatchToProps = dispatch => {
    return {
        updateSupportedClientType: (data, options) => dispatch(actions.editSupportedClientType(data, options)),
        loadSupportedClientType: data => dispatch(actions.loadSupportedClientType(data)),
        loadSupportedClientTypeInit: () => dispatch(actions.loadSupportedClientTypeInit()),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SupportedClientTypeEdit);
